'use client'

import Script from 'next/script'

// Carga el script de Google Identity Services y notifica al resto de la app
// cuando está listo. Vive en su propio client component porque el `onLoad`
// de `next/script` necesita ejecutarse en el cliente (el `[locale]/layout.tsx`
// es server component).
//
// Disparamos un CustomEvent `gis-loaded` para que `GoogleOneTap` sepa cuándo
// puede llamar a `google.accounts.id.initialize/prompt`. Sin esto, el One Tap
// se inicializa antes de que el script esté disponible y falla silenciosamente.
const GoogleScriptLoader = () => (
  <Script
    src='https://accounts.google.com/gsi/client'
    strategy='afterInteractive'
    async
    defer
    onLoad={() => {
      window.dispatchEvent(new CustomEvent('gis-loaded'))
    }}
    onError={(e) => {
      console.error('Failed to load Google Identity Services script', e)
    }}
  />
)

export default GoogleScriptLoader
